import React from 'react';
import BottomFooterLinks from './BottomFooterLinks/BottomFooterLinks';
import FooterEmailSignUp from './FooterEmailSignUp/FooterEmailSignUp';
import FooterLinks from './FooterLinks/FooterLinks';
import FooterMessaging from './FooterMessaging/FooterMessaging';
import { useAppSelector } from '../../../store/store';
import { footerTaxoSelector } from '../../../store/selectors/taxonomySelector';
import { storeIdentifierNameSelector } from '../../../store/selectors/commonSelector';
import './FooterPL.scss';

export default function FooterPL() {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const taxoContent = useAppSelector(footerTaxoSelector);

  return (
    <div className="footerV2-container-2021" data-testid="footer-links">
      <div className="footerV2-filler-space hmf-py-xxl" />
      <FooterEmailSignUp
        footerEmailSignUpData={taxoContent.footerEmailSignup}
        storeIdentifierName={storeIdentifierName}
      />
      {taxoContent.footerV2Messaging ? (
        <FooterMessaging
          footerMessagingData={taxoContent.footerV2Messaging}
          storeIdentifierName={storeIdentifierName}
        />
      ) : null}
      <FooterLinks
        footerLinksData={taxoContent['Footer Links'] && taxoContent['Footer Links'][0].csvData}
        storeIdentifierName={storeIdentifierName}
      />
      <BottomFooterLinks
        bottomFooterLinksData={taxoContent['Footer Links'] && taxoContent['Footer Links'][0].cta}
        storeIdentifierName={storeIdentifierName}
      />
    </div>
  );
}
